import {
  ChangeDetectorRef,
  Component,
  inject,
  Input,
  PLATFORM_ID,
} from '@angular/core';
import { SectionTitleComponent } from '../../../shared/components/ui-elements/section-title/section-title.component';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { DestinationsService } from '../../../reducers/services/destinations.service';
import { UpcomingPropertyCarouselComponent } from '../../../shared/components/carousels/upcoming-property-carousel/upcoming-property-carousel.component';

@Component({
  selector: 'app-home-upcoming-properties',
  standalone: true,
  imports: [
    UpcomingPropertyCarouselComponent,
    SectionTitleComponent,
    CommonModule,
],
  templateUrl: './home-upcoming-properties.component.html',
  styleUrl: './home-upcoming-properties.component.scss',
})
export class HomeUpcomingPropertiesComponent {
  @Input() title: string = '';
  upcominghotels!: any[];
  isBrowser: boolean = false;

  constructor(
    private destinationsService: DestinationsService,
    private cdr: ChangeDetectorRef
  ) {
    const platformId = inject(PLATFORM_ID);
    this.isBrowser = isPlatformBrowser(platformId);
  }

  ngOnInit(): void {
    this.getUpcomingHotel();
  }

  getUpcomingHotel() {
    this.destinationsService
      .getUpcomingHotelsList()
      .pipe()
      .subscribe({
        next: (response: any) => {
          this.upcominghotels = response || [];
        },
        error: (err: any) => {
          console.error('Failed to fetch blogs:', err);
        },
      });
  }
}
